const mockData = {
  active: [
    {
      ID: 1,
      firstName: "John Jacob Jingleheimer Schmidt",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: true,
    },
    {
      ID: 2,
      firstName: "Goodnight Moon",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "donation",
      forActivePledge: true,
    },
    {
      ID: 3,
      firstName: "Janner Wingfeather",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "payment",
      forActivePledge: true,
    },
    {
      ID: 11,
      firstName: "Hello World",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      nextPaymentDate: "2022-10-15",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 12,
      firstName: "Goodnight Moon",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 13,
      firstName: "Janner Wingfeather",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 21,
      firstName: "Hello World",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      nextPaymentDate: "2022-10-15",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 22,
      firstName: "Goodnight Moon",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 23,
      firstName: "Janner Wingfeather",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 31,
      firstName: "Hello World",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      nextPaymentDate: "2022-10-15",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 32,
      firstName: "Goodnight Moon",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 33,
      firstName: "Janner Wingfeather",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: false,
    },
  ],
  paused: [
    {
      ID: 4,
      firstName: "Tink Igiby",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      nextPaymentDate: "2022-10-15",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 5,
      firstName: "Frodo Baggins",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 99,
      firstName: "Lily Hammersmith",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: false,
    },
  ],
  stopped: [
    {
      ID: 6,
      firstName: "Hello World",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      nextPaymentDate: "2022-10-15",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 7,
      firstName: "Goodnight Moon",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 8,
      firstName: "Janner Wingfeather",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: false,
    },
  ],
  ended: [
    {
      ID: 9,
      firstName: "Hello World",
      userID: 52,
      amount: "$350",
      interval: "monthly",
      endDate: "2022-10-23",
      nextPaymentDate: "2022-10-15",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 10,
      firstName: "Goodnight Moon",
      userID: 52,
      amount: "$50",
      interval: "weekly",
      endDate: "2022-11-23",
      nextPaymentDate: "2022-10-11",
      paymentType: "gift",
      forActivePledge: false,
    },
    {
      ID: 11,
      firstName: "Janner Wingfeather",
      userID: 52,
      amount: "$101",
      interval: "monthly",
      endDate: "2025-10-23",
      nextPaymentDate: "2022-10-23",
      paymentType: "gift",
      forActivePledge: false,
    },
  ],
};
export default mockData;
